<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <div class="times">
          <Times @getTime="getTime" ref="times"></Times>
          <el-form :model="query" ref="queryForm" :inline="true">
            <el-form-item label="大区信息：">
              <el-input v-model="query.keyword" placeholder="请输入姓名/手机号" clearable size="small" />
            </el-form-item>
          </el-form>
        </div>
        <div class="btns">
          <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
          <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
        </div>
      </div>
      <div class="nav-container">
        <Navs ref="navs" :navList="navList" @changeNav="changeNav" @exportEv="exportEv"></Navs>
      </div>
      <div class="data-container mt20">
        <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
          <el-table-column label="排名" type="index" align="center" width="60"></el-table-column>
          <el-table-column label="大区信息" prop="name" align="center">
            <template slot-scope="{row}">
              <div>
                <span style="display: block;">{{ row.name }}</span>
                <span style="display: block;">{{ row.phone }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="总佣金" prop="kickback" sortable="custom" align="center">
            <template slot-scope="{row}">
              <span style="color: #60B7DC;cursor: pointer;" @click="toPage('/count/kickback/commission',row)">{{ row.kickback }}</span>
            </template>
          </el-table-column>
          <el-table-column label="团队佣金" prop="tdKickback" sortable="custom" align="center"></el-table-column>
          <el-table-column label="客户佣金" prop="khKickback" sortable="custom" align="center" width="100"></el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </div>
    </el-card>
  </div>
</template>

<script>
import sysDataconstantApi from '@/api/config/sysDataconstant'
import Pagination from '@/components/Pagination'
import Times from '../components/times.vue'
import Navs from '../components/navs.vue'

export default {
  components: {
    Pagination,
    Times,
    Navs
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        isDisplay: 1,
        keyword:'',
        identity:''
      },
      selectItems: [],
      times: null,
      navList: [],
      navIndex: 0
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else if (order === 'descending') {
            this.query[sortKey] = -1
          } else {
            this.query[sortKey] = 0
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 获取时间段
     */
     getTime(event) {
      this.times = JSON.parse(event)
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发重置操作
     */
     handleFilter() {
      this.$refs.times.timeIndex = 0
      this.$refs.times.timeShow = ''
      this.$refs.times.timeStart = ''
      this.$refs.times.timeEnd = ''
      this.query.keyword = ''
      this.query.identity = ''
       this.times = null;
       this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发导航切换
     */
    changeNav(index) {
        this.navIndex = index;
        this.doQueryList({ pageNo: 1 });
    },
    /**
     * 触发导出
     */
    exportEv() {
      this.$router.push('/count/kickback/export')
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return sysDataconstantApi.fetchList(this.query).then(({ data }) => {
        data.list = [
          {name: '张三',phone: '15692915737',kickback: 500,tdKickback: 300,khKickback: 200},
          {name: '张三',phone: '15692915737',kickback: 500,tdKickback: 300,khKickback: 200},
          {name: '张三',phone: '15692915737',kickback: 500,tdKickback: 300,khKickback: 200},
          {name: '张三',phone: '15692915737',kickback: 500,tdKickback: 300,khKickback: 200},
          {name: '张三',phone: '15692915737',kickback: 500,tdKickback: 300,khKickback: 200},
          {name: '张三',phone: '15692915737',kickback: 500,tdKickback: 300,khKickback: 200},
        ]
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    changeSwitch(row) {
      sysDataconstantApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 页面跳转
     */
    toPage(path,row,type) {
      if(type) {
        this.$router.push(`${path}?id=${row.id}&index=${type-1}`)
      }else{
        this.$router.push(`${path}?id=${row.id}`)
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .filter-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 0;
    .times {
      display: flex;
      align-items: center;
    }
    .btns {
      margin-bottom: 22px;
    }
  }
</style>